import { render, staticRenderFns } from "./StatusEquipamento.vue?vue&type=template&id=4f8c5332&"
import script from "./StatusEquipamento.vue?vue&type=script&lang=js&"
export * from "./StatusEquipamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports